import { Formik } from 'formik'
import { useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap'
import 'react-toggle/style.css'
import api from '../../../config/AxiosInstance'
import '../../../styles/style.css'
import * as Common from '../../../utils/Common'
import { StagingAreaAddSchema } from '../../../utils/validationSchema'
import CustomButton from '../../Button/CustomButton'
import CustomCloseButton from '../../Button/CustomCloseButton'
import TextField from '../../Input/TextInput'

function ModalAddStagingArea(props) {
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const handleSubmit = async (values, actions) => {
    try {
      setLoadingSubmit(true)
      const response = await api.post('/master/stagings', values)
      if (response.data.success) {
        props.onHide()
        props.refreshData()
        Common.showPopUpSuccessMessage(response.data.message)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingSubmit(false)
    }
  }

  return (
    <Modal {...props} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Staging Area</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{
            staging_name: '',
            block_total: ''
          }}
          validationSchema={StagingAreaAddSchema}
          onSubmit={(values) => {
            values.warehouse_id = props.data
            handleSubmit(values)
          }}
        >
          {({
            handleBlur,
            handleSubmit,
            handleChange,
            values,
            setFieldValue,
            errors,
            touched,
            isValid,
            dirty
          }) => {
            return (
              <Form className="d-grid gap-2" onSubmit={handleSubmit}>
                <Row>
                  <Col md={12}>
                    <TextField
                      id="staging_name"
                      label="NAME"
                      name="staging_name"
                      value={values.staging_name}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      className="mb-1"
                      required={true}
                    />
                  </Col>
                  <Col md={12}>
                    <TextField
                      id="block_total"
                      label="TOTAL BLOCK"
                      name="block_total"
                      value={values.block_total}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      className="mb-1"
                      required={true}
                      type="number"
                    />
                  </Col>
                </Row>
                <Modal.Footer className="mt-3">
                  <CustomCloseButton onClick={props.onHide} />
                  <CustomButton
                    onClick={handleSubmit}
                    variant={
                      !isValid || !dirty || loadingSubmit
                        ? 'secondary'
                        : 'warning'
                    }
                    disabled={!isValid || !dirty || loadingSubmit}
                    text={loadingSubmit ? 'Loading...' : 'Add'}
                    classNameValue={`text-white ${
                      !isValid || !dirty || loadingSubmit ? 'opacity-25' : ''
                    }`}
                  />
                </Modal.Footer>
              </Form>
            )
          }}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export default ModalAddStagingArea
